import React, { Component } from 'react';
import { Field, FieldArray, reduxForm } from 'redux-form';
import './CreateQuotesForm.css';
import FormDateTimePicker from 'components/shared/form/FormDateTimePicker';
import { todayValidation } from 'services/utils/date-util';
import moment from 'moment';
import FormDropDown from 'components/shared/form/FormDropDown';
import CreateQuoteModal from 'components/admin/work-orders/details/quotes/CreateQuoteModal';
import FormInput from 'components/shared/form/FormInput';
import FormTextArea from 'components/shared/form/FormTextArea';

class CreateQuotesForm extends Component {
  render() {
    return (
      <div className="create-quotes-form">
        <form onSubmit={this.props.handleSubmit}>
          <table className="create-quotes-form-table">
            <colgroup>
              <col />
              <col />
              <col />
              <col />
              <col />
              <col />
              <col />
              <col />
            </colgroup>
            <thead>
              <tr>
                <th>TASK</th>
                <th>TYPE</th>
                <th>TARGET COMPLETION DATE</th>
                <th>START DATE</th>
                <th>DURATION IN DAYS</th>
                <th>MATERIAL LEAD TIME IN DAYS</th>
                <th>TOTAL COST</th>
                <th>DESCRIPTION/QUALIFICATIONS</th>
              </tr>
            </thead>
            <FieldArray component={this.renderFields} name="fields" />
          </table>
          <input
            className="btn button button-orange"
            type="submit"
            value="Continue"
          />
        </form>
      </div>
    );
  }

  renderFields = ({ fields }) => {
    return (
      <tbody>
        {fields.map((item, index) => {
          const field = fields.get(index);
          const taskNumber = field.taskNumber;
          const completionDateMoment = moment(field.taskCompletionDate);
          return (
            <tr key={index}>
              <td>{taskNumber}</td>
              <td>{field.taskType}</td>
              <td>{completionDateMoment.format('M/D/YYYY')}</td>
              <td>
                <Field
                  component={FormDateTimePicker}
                  isValidDate={(date) =>
                    todayValidation(date) &&
                    date.isSameOrBefore(completionDateMoment)
                  }
                  name={`${item}.startDate`}
                  placeholder="Start date"
                  type="text"
                />
              </td>
              <td>
                <Field
                  component={FormDropDown}
                  name={`${item}.durationInDays`}
                  options={CreateQuoteModal.createDurationOptions()}
                  placeholder="Duration"
                />
              </td>
              <td>
                <Field
                  component={FormDropDown}
                  clearable={true}
                  name={`${item}.materialLeadDays`}
                  options={CreateQuoteModal.createMaterialLeadDaysOptions()}
                  placeholder="Lead Time"
                />
              </td>
              <td>
                <Field
                  component={FormInput}
                  name={`${item}.totalCost`}
                  placeholder="Total Cost"
                  type="number"
                />
              </td>
              <td>
                <Field
                  component={FormTextArea}
                  name={`${item}.description`}
                  placeholder="Is there anything the Spackle team should know regarding your quote, process or experience? (Please be sure to include any exclusions)."
                />
              </td>
            </tr>
          );
        })}
      </tbody>
    );
  };
}

function validate(values) {
  const fieldsArrayErrors = [];
  values.fields.forEach((item, index) => {
    const fieldErrors = {};
    if (!item || !item.startDate) {
      fieldErrors.startDate = 'Required';
      fieldsArrayErrors[index] = fieldErrors;
    }
    if (!item || !item.durationInDays) {
      fieldErrors.durationInDays = 'Required';
      fieldsArrayErrors[index] = fieldErrors;
    }
    if (!item || !item.totalCost) {
      fieldErrors.totalCost = 'Required';
      fieldsArrayErrors[index] = fieldErrors;
    }
  });
  const errors = {};
  if (fieldsArrayErrors.length > 0) {
    errors.fields = fieldsArrayErrors;
  }
  return errors;
}

export default reduxForm({
  form: 'CreateQuotesForm',
  validate,
})(CreateQuotesForm);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/quotes/CreateQuotesForm.js